export type Tag = {
  id: string;
  name: string;
};

export const TAGS_LIST_1_SUBSCRIPTION = (t?: any): Tag[] => [
  {
    id: t?.('sessiontaga') ?? 'sessiontaga',
    name: t?.('sessiontaga') ?? 'sessiontaga',
  },
  {
    id: t?.('sessiontagr') ?? 'sessiontagr',
    name: t?.('sessiontagr') ?? 'sessiontagr',
  },
  {
    id: t?.('sessiontags') ?? 'sessiontags',
    name: t?.('sessiontags') ?? 'sessiontags',
  },
  {
    id: t?.('sessiontagh') ?? 'sessiontagh',
    name: t?.('sessiontagh') ?? 'sessiontagh',
  },
  {
    id: 'other',
    name: t?.('sessiontagf') ?? 'other',
  },
];

export const TAGS_LIST_2_SUBSCRIPTION = (t?: any): Tag[] => [
  {
    id: t?.('sessiontaga') ?? 'sessiontaga',
    name: t?.('sessiontaga') ?? 'sessiontaga',
  },
  {
    id: t?.('sessiontagr') ?? 'sessiontagr',
    name: t?.('sessiontagr') ?? 'sessiontagr',
  },
  {
    id: t?.('sessiontagh') ?? 'sessiontagh',
    name: t?.('sessiontagh') ?? 'sessiontagh',
  },
  {
    id: 'other',
    name: t?.('sessiontagf') ?? 'other',
  },
];

export const TAGS_LIST_3_SUBSCRIPTION = (t?: any): Tag[] => [
  {
    id: t?.('sessiontagy') ?? 'sessiontagy',
    name: t?.('sessiontagy') ?? 'sessiontagy',
  },
  {
    id: t?.('sessiontagt') ?? 'sessiontagt',
    name: t?.('sessiontagt') ?? 'sessiontagt',
  },
  {
    id: 'other',
    name: t?.('sessiontagf') ?? 'other',
  },
];

export const TAGS_BY_RATING_SUBSCRIPTION = (t?: any): Record<number, Tag[]> => ({
  1: TAGS_LIST_1_SUBSCRIPTION(t),
  2: TAGS_LIST_1_SUBSCRIPTION(t),
  3: TAGS_LIST_2_SUBSCRIPTION(t),
  4: TAGS_LIST_3_SUBSCRIPTION(t),
  5: TAGS_LIST_3_SUBSCRIPTION(t),
});
